module.exports = __webpack_public_path__ + "img/home-fqa-1.34a81f58.svg";